import React, { useState } from "react";
import axios from "axios";
import { IoMdClose } from "react-icons/io";
import { VscLoading } from "react-icons/vsc";

const CloseLoanModal = ({
  closeModal,
  orderUuid,
  setSuccessAPI,
  setErrorAPI,
  setRerender,
}) => {
  const token = localStorage.getItem("token");
  const [textCount, setTextCount] = useState(0);
  const [comment, setComment] = useState("");
  const [error, setError] = useState("");
  const validateInput = () => {
    if (!comment || comment.length <= 0)
      return "Please Enter a comment to close the loan.";
  };
  const [loading, setLoading] = useState(false);

  const handleClosLoan = async () => {
    const errorMessage = validateInput();
    if (errorMessage) {
      setError(errorMessage);
      return;
    }
    setLoading(true);
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/bajaj_finserv/service/failed_closure`,

        method: "POST",
        headers: { Authorization: token },
        data: {
          failed_closure: {
            order_uuid: orderUuid,
            message: comment,
          },
        },
      };
      const res = await axios(options);

      if (res?.data?.status) {
        const message = res?.data?.data?.message;
        setSuccessAPI(message || "Overdraft loan closed successfully");
        setRerender((prev) => !prev);
        closeModal(false);
      } else {
        const message = res?.data?.error;
        setErrorAPI(message || "Error in closing the overdraft");
      }
    } catch (error) {
      setError("An error occured, please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="overlay z-50">
      <div className={`modal !w-[380px]  !h-fit !p-0 !text-left `}>
        <div className=" w-full h-full p-6 flex flex-col">
          <div className=" flex justify-between items-center text-base font-bold">
            <p>Close Overdraft Loan</p>
            <IoMdClose
              className=" w-[20px] h-[20px] cursor-pointer"
              onClick={() => {
                closeModal(false);
              }}
            />
          </div>

          <p className=" mt-4 text-xs font-medium">
            Comment (150 characters) max
          </p>
          <textarea
            value={comment}
            maxLength={150}
            onChange={(e) => {
              setError("");

              setTextCount(e.target.textLength);
              setComment(e.target.value);
            }}
            className={` resize-none mt-2 border  ${
              error === "Please enter a comment to save"
                ? " border-red-600"
                : "border-[#e0e0e0]"
            } rounded h-[100px] focus:outline-none focus:border-[#00394d] text-sm p-2`}
          />
          <div className=" ml-1 mt-1 flex justify-between text-[10px] pr-[2px]">
            <p className="  text-[#262626]">{textCount}/150</p>
            {error && <p className=" text-red-600">{error}</p>}
          </div>

          <button
            onClick={() => {
              handleClosLoan();
            }}
            className=" ml-auto flex  items-center justify-center bg-[#00394d] text-white h-[32px] w-[94px] rounded-lg text-sm font-semibold"
          >
            {loading ? (
              <VscLoading size={16} className=" animate-spin" />
            ) : (
              " Close "
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CloseLoanModal;
